module.exports = __webpack_public_path__ + "static/02-d523c034104fdeac8d81e865161fe501.jpg";